// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/video.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_common } from "./common_pb.js";
import { file_vitesse_v1_controller } from "./controller_pb.js";
/**
 * Describes the file vitesse/v1/video.proto.
 */
export const file_vitesse_v1_video = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_entitlements, file_vitesse_v1_common, file_vitesse_v1_controller]);
/**
 * Describes the message vitesse.v1.CameraDescriptor.
 * Use `create(CameraDescriptorSchema)` to create a new message.
 */
export const CameraDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 0);
/**
 * Describes the message vitesse.v1.CameraMetrics.
 * Use `create(CameraMetricsSchema)` to create a new message.
 */
export const CameraMetricsSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 1);
/**
 * Describes the message vitesse.v1.TurnDescriptor.
 * Use `create(TurnDescriptorSchema)` to create a new message.
 */
export const TurnDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 2);
/**
 * Describes the message vitesse.v1.WatchCameraRequest.
 * Use `create(WatchCameraRequestSchema)` to create a new message.
 */
export const WatchCameraRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 3);
/**
 * Describes the message vitesse.v1.WatchCameraReply.
 * Use `create(WatchCameraReplySchema)` to create a new message.
 */
export const WatchCameraReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 4);
/**
 * Describes the message vitesse.v1.PublishCameraRequest.
 * Use `create(PublishCameraRequestSchema)` to create a new message.
 */
export const PublishCameraRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 5);
/**
 * Describes the message vitesse.v1.PublishCameraReply.
 * Use `create(PublishCameraReplySchema)` to create a new message.
 */
export const PublishCameraReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 6);
/**
 * Describes the message vitesse.v1.MintIngestTokenRequest.
 * Use `create(MintIngestTokenRequestSchema)` to create a new message.
 */
export const MintIngestTokenRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 7);
/**
 * Describes the message vitesse.v1.MintIngestTokenReply.
 * Use `create(MintIngestTokenReplySchema)` to create a new message.
 */
export const MintIngestTokenReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 8);
/**
 * Describes the message vitesse.v1.RevokeProducerRequest.
 * Use `create(RevokeProducerRequestSchema)` to create a new message.
 */
export const RevokeProducerRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 9);
/**
 * Describes the message vitesse.v1.RevokeProducerReply.
 * Use `create(RevokeProducerReplySchema)` to create a new message.
 */
export const RevokeProducerReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 10);
/**
 * Describes the message vitesse.v1.QueryRecordingRequest.
 * Use `create(QueryRecordingRequestSchema)` to create a new message.
 */
export const QueryRecordingRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 11);
/**
 * Describes the message vitesse.v1.RecordingSegment.
 * Use `create(RecordingSegmentSchema)` to create a new message.
 */
export const RecordingSegmentSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 12);
/**
 * Describes the message vitesse.v1.QueryRecordingReply.
 * Use `create(QueryRecordingReplySchema)` to create a new message.
 */
export const QueryRecordingReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 13);
/**
 * Describes the message vitesse.v1.FetchSegmentRangeRequest.
 * Use `create(FetchSegmentRangeRequestSchema)` to create a new message.
 */
export const FetchSegmentRangeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 14);
/**
 * Describes the message vitesse.v1.FetchSegmentRangeReply.
 * Use `create(FetchSegmentRangeReplySchema)` to create a new message.
 */
export const FetchSegmentRangeReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 15);
/**
 * Describes the message vitesse.v1.SnapshotRequest.
 * Use `create(SnapshotRequestSchema)` to create a new message.
 */
export const SnapshotRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 16);
/**
 * Describes the message vitesse.v1.SnapshotReply.
 * Use `create(SnapshotReplySchema)` to create a new message.
 */
export const SnapshotReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 17);
/**
 * Describes the message vitesse.v1.SetRecordingRequest.
 * Use `create(SetRecordingRequestSchema)` to create a new message.
 */
export const SetRecordingRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 18);
/**
 * Describes the message vitesse.v1.SetRecordingReply.
 * Use `create(SetRecordingReplySchema)` to create a new message.
 */
export const SetRecordingReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 19);
/**
 * Describes the message vitesse.v1.SetRecordingPausedRequest.
 * Use `create(SetRecordingPausedRequestSchema)` to create a new message.
 */
export const SetRecordingPausedRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 20);
/**
 * Describes the message vitesse.v1.SetRecordingPausedReply.
 * Use `create(SetRecordingPausedReplySchema)` to create a new message.
 */
export const SetRecordingPausedReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 21);
/**
 * Describes the message vitesse.v1.SetRecordingCircularRequest.
 * Use `create(SetRecordingCircularRequestSchema)` to create a new message.
 */
export const SetRecordingCircularRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 22);
/**
 * Describes the message vitesse.v1.SetRecordingCircularReply.
 * Use `create(SetRecordingCircularReplySchema)` to create a new message.
 */
export const SetRecordingCircularReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 23);
/**
 * Describes the message vitesse.v1.VideoSubscribeRequest.
 * Use `create(VideoSubscribeRequestSchema)` to create a new message.
 */
export const VideoSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 24);
/**
 * Describes the message vitesse.v1.CameraEvent.
 * Use `create(CameraEventSchema)` to create a new message.
 */
export const CameraEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 25);
/**
 * @generated from enum vitesse.v1.CameraEvent.Op
 */
export var CameraEvent_Op;
(function (CameraEvent_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    CameraEvent_Op[CameraEvent_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * descriptor present
     *
     * @generated from enum value: OP_PUT = 1;
     */
    CameraEvent_Op[CameraEvent_Op["PUT"] = 1] = "PUT";
    /**
     * camera removed; descriptor unset
     *
     * @generated from enum value: OP_DELETE = 2;
     */
    CameraEvent_Op[CameraEvent_Op["DELETE"] = 2] = "DELETE";
})(CameraEvent_Op || (CameraEvent_Op = {}));
/**
 * Describes the enum vitesse.v1.CameraEvent.Op.
 */
export const CameraEvent_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_video, 25, 0);
/**
 * Describes the message vitesse.v1.VideoWatchRequest.
 * Use `create(VideoWatchRequestSchema)` to create a new message.
 */
export const VideoWatchRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 26);
/**
 * Describes the message vitesse.v1.VideoSnapshotRequest.
 * Use `create(VideoSnapshotRequestSchema)` to create a new message.
 */
export const VideoSnapshotRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 27);
/**
 * Describes the message vitesse.v1.VideoSetRecordingRequest.
 * Use `create(VideoSetRecordingRequestSchema)` to create a new message.
 */
export const VideoSetRecordingRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 28);
/**
 * Describes the message vitesse.v1.VideoSetRecordingPausedRequest.
 * Use `create(VideoSetRecordingPausedRequestSchema)` to create a new message.
 */
export const VideoSetRecordingPausedRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 29);
/**
 * Describes the message vitesse.v1.VideoSetRecordingCircularRequest.
 * Use `create(VideoSetRecordingCircularRequestSchema)` to create a new message.
 */
export const VideoSetRecordingCircularRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_video, 30);
/**
 * @generated from service vitesse.v1.Video
 */
export const Video = /*@__PURE__*/ serviceDesc(file_vitesse_v1_video, 0);
//# sourceMappingURL=video_pb.js.map